<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>
<template>
  <div class="relative w-full h-screen flex items-center justify-start">
    <img
      src="@/../img/home/checkup.jpg"
      alt="Background"
      class="absolute w-full h-full object-cover rounded-lg shadow-lg"
    />
    <!-- Dark Overlay for Readability -->
    <div class="absolute inset-0 bg-black bg-opacity-80"></div>
    <div class="section-container">
      <div class="relative z-10 text-white">
        <!-- Main Title -->
        <h1
          class="text-5xl md:text-6xl leading-tight"
        >{{ $t('Zorgblik: Uw partner voor zorgoplossingen') }}</h1>

        <!-- Subtitle -->
        <p
          class="mt-4 text-lg md:text-xl font-medium"
        >{{ $t('Zorgblik verbindt zorginstellingen met ervaren zorgprofessionals.') }}</p>

        <!-- Buttons -->
        <div class="mt-6 flex flex-wrap gap-4 justify-center">
          <button
            class="bg-[#437066] text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-[#355a50] transition"
          >{{ $t('Zorgprofessionals') }}</button>
          <button
            class="bg-[#437066] text-white px-6 py-3 rounded-lg text-lg font-semibold hover:bg-[#355a50] transition"
          >{{ $t('Zorginstellingen') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>